import Vue from 'vue';
import router from './router';

import App from './App.vue';

import axios from 'axios';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '../static/index.css';
import theme from './theme';
import wamp from './wamp';
import store, { ViewCard } from './store';

import VueApollo from 'vue-apollo';

import round from 'vue-round-filter';
import moment from 'vue-moment';
import { apolloClient } from './apollo';
import Feature from 'src/misc/external/feature.ts';

declare var USE_AUTH;

Vue.use(Vuetify, {
  theme,
});

Vue.use(Feature);
Vue.use(VueApollo);

Vue.use(moment);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Feature.visibility('simulate', () => {
  const developer = router.currentRoute.query.developer;
  return developer === 'true' || developer === null;
});

Vue.filter('round', round);

Vue.filter('lowercase', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.toLowerCase();
});

const v = new Vue({
  el: '#app',
  template: '<App/>',
  components: { App, Feature },
  provide: apolloProvider.provide(),
  router,
  store,
  // created: () => {
  //   console.log(`Vue app is created`);
  //   let app = document.getElementById("app");
  //   app.focus();
  // },
  // errorCaptured: (err, vm, info) => {
  //   console.error(`Vue error: `, err);
  // },
});

axios.get(`/get-wamp`).then(async (response) => {
  // console.log(response);
  const w = response.data;
  console.log(`WAMP config: `, w);

  // const url = `ws://${window.location.hostname}:${ports.wampPort}`;
  await wamp.connect(w.url, w.realm, w.auth);
}).catch((error) => {
  console.log(error);
});

if (module.hot) {
  // Hot reload can be handled here to prevent a full reload.
  // module.hot.accept();
  // module.hot.accept('./router.ts', function() {
  // });
}

export { store, ViewCard };



// WEBPACK FOOTER //
// ./src/index.ts